import { getFeatureFlagValue } from './helper';
import { IDispatchManagerFeatures } from './interface';

export const dispatchManagerFeatures: IDispatchManagerFeatures = {
    isHideIntimetecMailIdUsers: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_HIDE_INTIMETEC_MAIL_ID_USERS,
    ),
    isShowSettingsInvoicing: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_SETTINGS_INVOICING,
    ),
    isRateBeingEntered: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_RATE_BEING_ENTERED,
    ),
    isShowInputAndDocumentPreferences: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_INPUT_AND_DOCUMENT_PREFERENCES,
    ),
    isShowSubscriptionComponent: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_SUBSCRIPTION_COMPONENT,
    ),
    isShowAllActivityItems: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_ALL_ACTIVITY_ITEMS,
    ),
    isShowBOLRequiredInMobileApp: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_BOL_REQUIRED_IN_MOBILE_APP,
    ),
    isAxiosApiCallNewImplementation: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_AXIOS_API_CALL_NEW_IMPLEMENTATION,
    ),
    isShowGeneralBrokerFee: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_GENERAL_BROKER_FEE,
    ),
    isShowSettlementReportModal: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_SETTLEMENT_REPORT_MODAL,
    ),
    isShowRoundInvoiceTotals: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_ROUND_INVOICE_TOTALS,
    ),
    isShowHeadCountOrQuantitySection: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_223080_IS_SHOW_HEAD_COUNT_OR_QUANTITY_SECTION,
    ),
    isShowOldSettlementReport: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_SHOW_OLD_SETTLEMENT_REPORT,
    ),
    isProfileImageOverlayRestricted: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_223169_IS_PROFILE_IMAGE_OVERLAY_RESTRICTED,
    ),
    isAbleToUploadHeicHeif: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241620_IS_ABLE_TO_UPLOAD_HEIC_HEIF,
    ),
    isShowModalOnAttachmentDelete: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241911_SHOW_MODAL_ON_ATTACHMENT_DELETE,
    ),
    isShowFormattedSettlementAmount: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_242336_SHOW_FORMATTED_SETTLEMENT_AMOUNT,
    ),
    isEnhancedLoadBoardEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_ENHANCED_LOAD_BOARD_ENABLED,
    ),
    showUpdateSignupPage: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_241940_SHOW_UPDATE_SIGNUP_PAGE,
    ),
    isBreakdownDriverDeletionRestricted: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_242562_RESTRICT_BREAKDOWN_DRIVER_DELETION,
    ),
    showSendSettlementReportToQuickBooks: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242691_SETTLEMENT_REPORT_TO_QB,
    ),
    isPosthogOn: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_POSTHOG_ON,
    ),
    isShowUpdateDriverCard: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_196665_IS_SHOW_UPDATE_DRIVER_CARD,
    ),
    isShowPreserveOwnerOperatorPercent: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242383_PRESERVE_OWNER_OPERATOR_PERCENT,
    ),
    showCargoSectionUIBugFix: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242943_CARGO_SECTION_UI_BUG,
    ),
    showTemplateFeature: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242133_SHOW_TEMPLATE_FEATURE,
    ),
    showManualConnectFeature: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_242209_SHOW_MANUAL_CONNECT_FEATURE,
    ),
    fixManualConnectPlaceholderDriver: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244746_FIX_MANUAL_CONNECT_PLACEHOLDER_DRIVER,
    ),
    isODataFilterFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_ODATA_FILTER_FIX_ENABLED,
    ),
    isSettlementReportEditingValidationEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_243121_SETTLEMENT_REPORT_EDITING_VALIDATION,
    ),
    enableDocumentDropdownResetOnDelete: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244095_ENABLE_DOCUMENT_DROPDOWN_RESET_ON_DELETE,
    ),
    isAdditionalChargeValidationEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244164_IS_ADDITIONAL_CHARGE_VALIDATION_ENABLED,
    ),
    isDispatcherQBUsersRestricted: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_244537_IS_DISPATCHER_RESTRICTED_FROM_FETCHING_QB_USERS,
    ),
    hideCustomerPhoneNumberInTemplate: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_HIDE_CUSTOMER_PHONE_NUMBER_IN_TEMPLATE,
    ),
    isMCSFeatureEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_MCS_FE,
    ),
    fixRescueDriverDetection: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_244738_FIX_RESCUE_DRIVER_DETECTION,
    ),
    isShowUpdatedAssignedDriverCount: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_244776_IS_SHOW_ASSIGNED_DRIVER_COUNT,
    ),
    isMandatoryDriverValidationEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_IS_MANDATORY_DRIVER_VALIDATION_ENABLED,
    ),
    isSyncBackUnsavedLoadDataFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_244795_IS_SYNC_BACK_UNSAVED_LOAD_DATA_FIX_ENABLED,
    ),
    isMultipleDispatchBugFixEnabledForDuplicateLoads: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_244853_IS_MULTIPLE_DISPATCH_BUG_FIX_ENABLED_FOR_DUPLICATE_LOADS,
    ),
    isBreakdownMilesFieldAppendingDigitsFixEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM_244916_IS_BREAKDOWN_MILES_FIELD_APPENDING_DIGITS_FIX_ENABLED,
    ),
    isShowMCSShipmentModalOnBuild: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_SHOW_MCS_SHIPMENT_MODAL_ON_BUILD,
    ),
    isFixDriverTimeOffDateCalculationBug: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_245032_FIX_DRIVER_TIME_OFF_DATE_CALCULATION_BUG,
    ),
    isBrokerFeeEmptyValueFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_IS_BROKER_FEE_EMPTY_VALUE_FIX_ENABLED,
    ),
    isDM245092ShipmentDetailOptimizationV1Enabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DM245092_SHIPMENT_DETAIL_OPTIMIZATION_V1_ENABLED,
    ),
    isCustomerScopedBrokerFeeEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_CUSTOMER_SCOPED_BROKER_FEE_ENABLED,
    ),
    isMCSBackendPdfGenerationEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DM_MCS_GENERATE_INVOICE_PDF_IN_BACKEND,
    ),
    isMCSSaveAndCloseOrderEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_MCS_SAVE_AND_CLOSE_ORDER,
    ),
    isMCSSaveToastEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_MCS_SAVE_TOAST,
    ),
    isSaveAndContinueButtonFixEnabled: getFeatureFlagValue(
        process.env.REACT_APP_FEATURE_DA_245470_SAVE_AND_CONTINUE_BUTTON_FIX,
    ),
    isSequentialDriverLoadAttachmentUploadEnabled: getFeatureFlagValue(
        process.env
            .REACT_APP_FEATURE_DA_SEQUENTIAL_DRIVER_LOAD_ATTACHMENT_UPLOAD_ENABLED,
    ),
};
